import ApiService from './ApiService'

export const getApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.is_active = data.selectedTab === 'active'
        }
        if (data?.company) {
            datas.company_code = data?.company
        }
        if (data?.customer) {
            datas.customer_code = data?.customer
        }
        if (data.id) {
            datas.id = data.id
        }
        if (data?.startDate) {
            datas.start_create_date = data?.startDate
        }
        if (data.endDate) {
            datas.end_create_date = data.endDate
        }
        if (data.status) {
            datas.codeDescr = data.status
        }
    }
    return ApiService.get('/api/v1/meson-app/meson-wms-inbound-devlivery/', datas)
}
export const createApiRecord = data => ApiService.post('/api/v1/meson-app/meson-wms-inbound-devlivery/', data)
export const getApiRecord = id => ApiService.get(`/api/v1/meson-app/meson-wms-inbound-devlivery/${id}/`)
export const updateApiRecord = (id, data) => ApiService.put(`/api/v1/meson-app/meson-wms-inbound-devlivery/${id}/`, data)
export const deleteApiRecord = id => ApiService.delete(`/api/v1/meson-app/meson-wms-inbound-devlivery/${id}/`)

export const getApiDetails = data => ApiService.get(`/api/v1/meson-app/meson-wms-inbound-devlivery-dtl/`, data)

export const getApiAsnStatusData = data => ApiService.get('/api/v1/meson-app/meson-wms-inbound-devlivery/status-list/', data)
